import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

export default function SfurtiTrustWebsite() {
  return (
    <div className="bg-white text-gray-800 scroll-smooth">
      {/* NAVBAR */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top shadow py-3">
        <div className="container">
          <a className="navbar-brand fw-bold fs-3 text-warning" href="#home">
            SFURTI TRUST
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto align-items-lg-center gap-lg-2">
              <li className="nav-item">
                <a className="nav-link" href="#about">About</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#mission">Mission</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#programs">Programmes</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#resources">Resources</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#health">Health</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#stories">Stories</a>
              </li>
              <li className="nav-item">
                <a className="btn btn-warning fw-bold px-4 ms-lg-3" href="#contact">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

     {/* HERO SECTION */}
<section
  id="home"
  className="d-flex align-items-center text-white position-relative overflow-hidden"
  style={{
    minHeight: "100vh",
    backgroundImage:
      'linear-gradient(rgba(0,0,0,0.78), rgba(0,0,0,0.78)), url("https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=1600&q=80")',
    backgroundSize: "cover",
    backgroundPosition: "center"
  }}
>
  <div className="container py-5">
    <div className="row align-items-center g-5">

      {/* LEFT CONTENT */}
      <div className="col-lg-7">

        <div className="mb-4">
          <span className="badge bg-warning text-dark px-4 py-3 rounded-pill fw-bold fs-6 shadow">
            Registered NGO • Since 2021 • Uttar Pradesh, Madhya Pradesh & Jharkhand
          </span>
        </div>

        <h1
          className="display-2 fw-bold mb-4"
          style={{ lineHeight: "1.15" }}
        >
          Driving Sustainable Development
          <span className="text-warning"> & </span>
          Social Empowerment
        </h1>

        <p
          className="lead fs-4 mb-4 text-light"
          style={{ maxWidth: "850px" }}
        >
          Sfurti Charitable Trust is a grassroots non-profit organization
          committed to uplifting underserved communities through
          education, digital literacy, women empowerment, vocational
          training, healthcare awareness, livelihood generation, and
          sustainable community development initiatives.
        </p>

        <p
          className="fs-5 text-light opacity-75 mb-5"
          style={{ maxWidth: "820px" }}
        >
          Established under the Indian Trust Act in 2021, we work across
          rural and urban regions of Uttar Pradesh, Madhya Pradesh, and
          Jharkhand to create opportunities, strengthen communities,
          reduce inequality, and empower individuals to lead lives of
          dignity, confidence, and self-reliance.
        </p>

        <div className="d-flex flex-wrap gap-3 mb-5">
          <a
            href="#about"
            className="btn btn-warning btn-lg fw-bold px-5 py-3 shadow"
          >
            Learn Our Story
          </a>

          <a
            href="#programs"
            className="btn btn-outline-light btn-lg px-5 py-3 fw-semibold"
          >
            Explore Programmes
          </a>

          <a
            href="#contact"
            className="btn btn-light btn-lg px-5 py-3 fw-semibold"
          >
            Contact Us
          </a>
        </div>

        {/* STATS */}
        <div className="row g-4">

          <div className="col-6 col-md-3">
            <div className="bg-white bg-opacity-10 backdrop-blur rounded-4 p-4 text-center border border-light border-opacity-25">
              <h2 className="fw-bold text-warning mb-1">3+</h2>
              <p className="mb-0 small text-light">
                States Covered
              </p>
            </div>
          </div>

          <div className="col-6 col-md-3">
            <div className="bg-white bg-opacity-10 rounded-4 p-4 text-center border border-light border-opacity-25">
              <h2 className="fw-bold text-warning mb-1">50+</h2>
              <p className="mb-0 small text-light">
                Community Programs
              </p>
            </div>
          </div>

          <div className="col-6 col-md-3">
            <div className="bg-white bg-opacity-10 rounded-4 p-4 text-center border border-light border-opacity-25">
              <h2 className="fw-bold text-warning mb-1">2021</h2>
              <p className="mb-0 small text-light">
                Founded
              </p>
            </div>
          </div>

          <div className="col-6 col-md-3">
            <div className="bg-white bg-opacity-10 rounded-4 p-4 text-center border border-light border-opacity-25">
              <h2 className="fw-bold text-warning mb-1">100%</h2>
              <p className="mb-0 small text-light">
                Community Focused
              </p>
            </div>
          </div>

        </div>
      </div>

      {/* RIGHT CONTENT */}
      <div className="col-lg-5">

        <div className="card border-0 shadow-lg rounded-4 overflow-hidden">
          <div className="card-body p-5 bg-white text-dark">

            <div className="text-center mb-4">
              <div
                className="bg-warning text-dark rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                style={{ width: "80px", height: "80px", fontSize: "2rem" }}
              >
                🌍
              </div>

              <h3 className="fw-bold">
                Empowering Communities
              </h3>

              <p className="text-muted">
                Building sustainable livelihoods through grassroots action.
              </p>
            </div>

            <div className="d-flex mb-4">
              <div className="me-3 fs-2 text-warning">
                👩‍🏫
              </div>

              <div>
                <h5 className="fw-bold mb-1">
                  Skill Development
                </h5>

                <p className="text-muted small mb-0">
                  Vocational and digital training programmes for youth and women.
                </p>
              </div>
            </div>

            <div className="d-flex mb-4">
              <div className="me-3 fs-2 text-warning">
                💻
              </div>

              <div>
                <h5 className="fw-bold mb-1">
                  Digital Literacy
                </h5>

                <p className="text-muted small mb-0">
                  ICT awareness and digital inclusion for underserved communities.
                </p>
              </div>
            </div>

            <div className="d-flex mb-4">
              <div className="me-3 fs-2 text-warning">
                🏥
              </div>

              <div>
                <h5 className="fw-bold mb-1">
                  Health & Hygiene
                </h5>

                <p className="text-muted small mb-0">
                  Menstrual health, sanitation awareness, and preventive care initiatives.
                </p>
              </div>
            </div>

            <div className="d-flex">
              <div className="me-3 fs-2 text-warning">
                🤝
              </div>

              <div>
                <h5 className="fw-bold mb-1">
                  Women Empowerment
                </h5>

                <p className="text-muted small mb-0">
                  Supporting SHGs, entrepreneurship, and economic independence.
                </p>
              </div>
            </div>

          </div>
        </div>

      </div>

    </div>
  </div>
</section>

      {/* ABOUT SECTION */}
<section
  id="about"
  className="py-5 position-relative overflow-hidden"
  style={{
    background: "linear-gradient(to bottom, #f8f9fa, #ffffff)"
  }}
>
  <div className="container py-5">

    <div className="row align-items-center g-5">

      {/* LEFT CONTENT */}
      <div className="col-lg-6">

        <span className="badge bg-primary-subtle text-primary px-4 py-2 rounded-pill mb-4 fw-semibold">
          ABOUT SFURTI CHARITABLE TRUST
        </span>

        <h2
          className="display-4 fw-bold mb-4"
          style={{ lineHeight: "1.2" }}
        >
          Commitment To
          <span className="text-primary"> Grassroots </span>
          Transformation
        </h2>

        <p className="lead text-muted mb-4">
          Sfurti Charitable Trust is a grassroots non-profit organization
          established on March 15, 2021 under the Indian Trust Act of 1882.
          Registered in Lucknow, Uttar Pradesh, our organization works across
          Uttar Pradesh, Madhya Pradesh, and Jharkhand to uplift underserved
          communities through sustainable development initiatives.
        </p>

        <p className="text-secondary fs-5 mb-4">
          At the heart of our mission is the belief that real and lasting
          change begins at the community level. We focus on programmes that
          promote education, women empowerment, livelihood generation,
          vocational training, digital inclusion, healthcare awareness,
          entrepreneurship support, and social welfare.
        </p>

        <p className="text-secondary fs-5 mb-5">
          Through collaboration with Self-Help Groups (SHGs), local leaders,
          youth groups, government bodies, and community stakeholders, we
          create opportunities that empower individuals to break the cycle
          of poverty and build lives of dignity, confidence, and
          self-reliance.
        </p>

        {/* FEATURES */}
        <div className="row g-4">

          <div className="col-md-6">
            <div className="d-flex align-items-start">
              <div
                className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3 shadow"
                style={{
                  width: "55px",
                  height: "55px",
                  fontSize: "1.4rem",
                  minWidth: "55px"
                }}
              >
                🎯
              </div>

              <div>
                <h5 className="fw-bold mb-2">
                  Mission Driven
                </h5>

                <p className="text-muted small mb-0">
                  Creating inclusive development opportunities for vulnerable communities.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="d-flex align-items-start">
              <div
                className="bg-warning text-dark rounded-circle d-flex align-items-center justify-content-center me-3 shadow"
                style={{
                  width: "55px",
                  height: "55px",
                  fontSize: "1.4rem",
                  minWidth: "55px"
                }}
              >
                🤝
              </div>

              <div>
                <h5 className="fw-bold mb-2">
                  Community Focused
                </h5>

                <p className="text-muted small mb-0">
                  Working directly with grassroots communities and local institutions.
                </p>
              </div>
            </div>
          </div>

        </div>

      </div>

      {/* RIGHT SIDE */}
      <div className="col-lg-6">

        <div className="row g-4">

          {/* CARD 1 */}
          <div className="col-sm-6">
            <div className="card border-0 shadow-lg rounded-4 h-100 overflow-hidden">

              <div
                className="bg-primary text-white text-center py-4"
              >
                <div className="display-4 fw-bold">
                  3+
                </div>

                <p className="mb-0 fw-semibold">
                  States Covered
                </p>
              </div>

              <div className="card-body text-center p-4">
                <p className="text-muted mb-0">
                  Active community programmes across Uttar Pradesh,
                  Madhya Pradesh, and Jharkhand.
                </p>
              </div>

            </div>
          </div>

          {/* CARD 2 */}
          <div className="col-sm-6">
            <div className="card border-0 shadow-lg rounded-4 h-100 overflow-hidden">

              <div
                className="bg-warning text-dark text-center py-4"
              >
                <div className="display-4 fw-bold">
                  2021
                </div>

                <p className="mb-0 fw-semibold">
                  Established
                </p>
              </div>

              <div className="card-body text-center p-4">
                <p className="text-muted mb-0">
                  Registered under the Indian Trust Act with a mission
                  to create lasting social impact.
                </p>
              </div>

            </div>
          </div>

          {/* VISION CARD */}
          <div className="col-12">
            <div className="card border-0 shadow-lg rounded-4 overflow-hidden">

              <div className="row g-0 align-items-center">

                <div className="col-md-4 bg-success text-white text-center p-5">

                  <div
                    className="bg-white text-success rounded-circle d-inline-flex align-items-center justify-content-center shadow mb-3"
                    style={{
                      width: "80px",
                      height: "80px",
                      fontSize: "2rem"
                    }}
                  >
                    🌍
                  </div>

                  <h3 className="fw-bold">
                    Our Vision
                  </h3>

                </div>

                <div className="col-md-8">
                  <div className="card-body p-5">

                    <p className="fs-5 text-muted mb-4">
                      We envision a future where every individual,
                      regardless of social or economic background,
                      has access to opportunities, education, healthcare,
                      and sustainable livelihood support.
                    </p>

                    <p className="mb-0 text-secondary">
                      Our goal is to build stronger and self-reliant
                      communities by promoting empowerment,
                      participation, equality, innovation,
                      and inclusive growth.
                    </p>

                  </div>
                </div>

              </div>

            </div>
          </div>

          {/* EXTRA INFO */}
          <div className="col-12">
            <div className="bg-dark text-white rounded-4 p-4 shadow">

              <div className="row text-center g-4">

                <div className="col-md-4">
                  <h2 className="fw-bold text-warning">
                    100%
                  </h2>

                  <p className="mb-0 small">
                    Community-Centered Approach
                  </p>
                </div>

                <div className="col-md-4">
                  <h2 className="fw-bold text-warning">
                    SHGs
                  </h2>

                  <p className="mb-0 small">
                    Women Empowerment Focus
                  </p>
                </div>

                <div className="col-md-4">
                  <h2 className="fw-bold text-warning">
                    ICT
                  </h2>

                  <p className="mb-0 small">
                    Digital Inclusion Programmes
                  </p>
                </div>

              </div>

            </div>
          </div>

        </div>

      </div>

    </div>

  </div>
</section>

     {/* MISSION SECTION */}
<section
  id="mission"
  className="py-5 position-relative overflow-hidden"
  style={{
    background:
      "linear-gradient(135deg, #0f172a 0%, #111827 50%, #1e293b 100%)"
  }}
>
  <div className="container py-5">

    {/* SECTION HEADER */}
    <div className="text-center mb-5">

      <span className="badge bg-warning text-dark px-4 py-2 rounded-pill fw-bold mb-4">
        OUR MISSION & OBJECTIVES
      </span>

      <h2 className="display-3 fw-bold text-white mb-4">
        Empowering Communities
        <span className="text-warning"> Through Sustainable </span>
        Development
      </h2>

      <p
        className="lead text-light opacity-75 mx-auto"
        style={{ maxWidth: "950px", lineHeight: "1.9" }}
      >
        Sfurti Charitable Trust is committed to empowering women,
        youth, children, and underserved communities through
        education, skill development, entrepreneurship support,
        digital literacy, healthcare awareness, livelihood generation,
        rights-based advocacy, and inclusive community participation.
      </p>

    </div>

    {/* MISSION CARDS */}
    <div className="row g-4">

      {/* CARD 1 */}
      <div className="col-lg-4 col-md-6">
        <div
          className="card h-100 border-0 rounded-4 shadow-lg text-white overflow-hidden"
          style={{
            background:
              "linear-gradient(135deg, rgba(37,99,235,0.18), rgba(59,130,246,0.08))",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255,255,255,0.1)"
          }}
        >

          <div className="card-body p-5">

            <div
              className="bg-primary rounded-circle d-flex align-items-center justify-content-center shadow mb-4"
              style={{
                width: "85px",
                height: "85px",
                fontSize: "2.3rem"
              }}
            >
              🎯
            </div>

            <h3 className="fw-bold mb-3">
              Inclusive Development
            </h3>

            <p className="text-light opacity-75 mb-4">
              Creating sustainable opportunities for marginalized
              communities through community-driven initiatives,
              social inclusion, and grassroots participation.
            </p>

            <ul className="list-unstyled small text-light opacity-75">

              <li className="mb-2">
                ✅ Community-centered programmes
              </li>

              <li className="mb-2">
                ✅ Poverty reduction initiatives
              </li>

              <li>
                ✅ Sustainable rural development
              </li>

            </ul>

          </div>
        </div>
      </div>

      {/* CARD 2 */}
      <div className="col-lg-4 col-md-6">
        <div
          className="card h-100 border-0 rounded-4 shadow-lg text-white overflow-hidden"
          style={{
            background:
              "linear-gradient(135deg, rgba(245,158,11,0.18), rgba(251,191,36,0.08))",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255,255,255,0.1)"
          }}
        >

          <div className="card-body p-5">

            <div
              className="bg-warning text-dark rounded-circle d-flex align-items-center justify-content-center shadow mb-4"
              style={{
                width: "85px",
                height: "85px",
                fontSize: "2.3rem"
              }}
            >
              🤝
            </div>

            <h3 className="fw-bold mb-3">
              Women Empowerment
            </h3>

            <p className="text-light opacity-75 mb-4">
              Supporting women-led Self-Help Groups (SHGs),
              entrepreneurship development, financial literacy,
              and economic independence for sustainable growth.
            </p>

            <ul className="list-unstyled small text-light opacity-75">

              <li className="mb-2">
                ✅ SHG formation & support
              </li>

              <li className="mb-2">
                ✅ Financial literacy training
              </li>

              <li>
                ✅ Women entrepreneurship programmes
              </li>

            </ul>

          </div>
        </div>
      </div>

      {/* CARD 3 */}
      <div className="col-lg-4 col-md-6">
        <div
          className="card h-100 border-0 rounded-4 shadow-lg text-white overflow-hidden"
          style={{
            background:
              "linear-gradient(135deg, rgba(16,185,129,0.18), rgba(52,211,153,0.08))",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255,255,255,0.1)"
          }}
        >

          <div className="card-body p-5">

            <div
              className="bg-success rounded-circle d-flex align-items-center justify-content-center shadow mb-4"
              style={{
                width: "85px",
                height: "85px",
                fontSize: "2.3rem"
              }}
            >
              💡
            </div>

            <h3 className="fw-bold mb-3">
              Skill & Digital Access
            </h3>

            <p className="text-light opacity-75 mb-4">
              Bridging the digital divide through vocational
              education, ICT awareness, digital literacy,
              and employment-oriented skill development.
            </p>

            <ul className="list-unstyled small text-light opacity-75">

              <li className="mb-2">
                ✅ Vocational skill training
              </li>

              <li className="mb-2">
                ✅ Computer & ICT literacy
              </li>

              <li>
                ✅ Youth employment support
              </li>

            </ul>

          </div>
        </div>
      </div>

      {/* CARD 4 */}
      <div className="col-lg-4 col-md-6">
        <div
          className="card h-100 border-0 rounded-4 shadow-lg text-white overflow-hidden"
          style={{
            background:
              "linear-gradient(135deg, rgba(239,68,68,0.18), rgba(248,113,113,0.08))",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255,255,255,0.1)"
          }}
        >

          <div className="card-body p-5">

            <div
              className="bg-danger rounded-circle d-flex align-items-center justify-content-center shadow mb-4"
              style={{
                width: "85px",
                height: "85px",
                fontSize: "2.3rem"
              }}
            >
              ⚖️
            </div>

            <h3 className="fw-bold mb-3">
              Rights & Governance
            </h3>

            <p className="text-light opacity-75 mb-4">
              Promoting transparency, civic awareness,
              RTI education, and citizen participation
              through rights-based advocacy programmes.
            </p>

            <ul className="list-unstyled small text-light opacity-75">

              <li className="mb-2">
                ✅ RTI awareness campaigns
              </li>

              <li className="mb-2">
                ✅ Legal rights education
              </li>

              <li>
                ✅ Civic participation initiatives
              </li>

            </ul>

          </div>
        </div>
      </div>

      {/* CARD 5 */}
      <div className="col-lg-4 col-md-6">
        <div
          className="card h-100 border-0 rounded-4 shadow-lg text-white overflow-hidden"
          style={{
            background:
              "linear-gradient(135deg, rgba(168,85,247,0.18), rgba(192,132,252,0.08))",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255,255,255,0.1)"
          }}
        >

          <div className="card-body p-5">

            <div
              className="bg-purple text-white rounded-circle d-flex align-items-center justify-content-center shadow mb-4"
              style={{
                width: "85px",
                height: "85px",
                fontSize: "2.3rem",
                backgroundColor: "#7c3aed"
              }}
            >
              🏥
            </div>

            <h3 className="fw-bold mb-3">
              Health & Hygiene
            </h3>

            <p className="text-light opacity-75 mb-4">
              Raising awareness about preventive healthcare,
              menstrual hygiene, sanitation, nutrition,
              and community well-being.
            </p>

            <ul className="list-unstyled small text-light opacity-75">

              <li className="mb-2">
                ✅ Health awareness workshops
              </li>

              <li className="mb-2">
                ✅ Menstrual hygiene education
              </li>

              <li>
                ✅ Sanitation & wellness drives
              </li>

            </ul>

          </div>
        </div>
      </div>

      {/* CARD 6 */}
      <div className="col-lg-4 col-md-6">
        <div
          className="card h-100 border-0 rounded-4 shadow-lg text-white overflow-hidden"
          style={{
            background:
              "linear-gradient(135deg, rgba(6,182,212,0.18), rgba(34,211,238,0.08))",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255,255,255,0.1)"
          }}
        >

          <div className="card-body p-5">

            <div
              className="bg-info text-dark rounded-circle d-flex align-items-center justify-content-center shadow mb-4"
              style={{
                width: "85px",
                height: "85px",
                fontSize: "2.3rem"
              }}
            >
              🚀
            </div>

            <h3 className="fw-bold mb-3">
              Entrepreneurship Support
            </h3>

            <p className="text-light opacity-75 mb-4">
              Encouraging micro-enterprises, rural entrepreneurship,
              MSME development, and sustainable livelihood opportunities.
            </p>

            <ul className="list-unstyled small text-light opacity-75">

              <li className="mb-2">
                ✅ MSME mentoring support
              </li>

              <li className="mb-2">
                ✅ Market linkage assistance
              </li>

              <li>
                ✅ Livelihood generation initiatives
              </li>

            </ul>

          </div>
        </div>
      </div>

    </div>

  </div>
</section>


     {/* PROGRAMMES SECTION */}
<section
  id="programs"
  className="py-5 position-relative overflow-hidden"
  style={{
    background: "linear-gradient(to bottom, #ffffff, #f8fafc)"
  }}
>
  <div className="container py-5">

    {/* SECTION HEADER */}
    <div className="text-center mb-5">

      <span className="badge bg-primary-subtle text-primary px-4 py-2 rounded-pill fw-semibold mb-4">
        OUR CORE PROGRAMMES
      </span>

      <h2 className="display-3 fw-bold mb-4">
        Building Stronger Communities
        <span className="text-primary"> Through Action</span>
      </h2>

      <p
        className="lead text-muted mx-auto"
        style={{
          maxWidth: "900px",
          lineHeight: "1.9"
        }}
      >
        Sfurti Charitable Trust drives meaningful impact through
        specialized community interventions focused on education,
        livelihood generation, digital inclusion, women empowerment,
        healthcare awareness, vocational skills, and entrepreneurship
        development.
      </p>

    </div>

    {/* PROGRAMME CARDS */}
    <div className="row g-4">

      {[
        {
          icon: "👩‍💼",
          title: "Women Empowerment & SHGs",
          desc:
            "Organizing women into Self-Help Groups (SHGs) to promote financial literacy, entrepreneurship, leadership, savings culture, and economic independence.",
          points: [
            "Financial literacy & savings",
            "Women-led entrepreneurship",
            "SHG capacity building"
          ],
          color: "primary"
        },

        {
          icon: "💻",
          title: "Digital Literacy & ICT",
          desc:
            "Bridging the digital divide through computer education, ICT awareness, internet literacy, online safety, and digital access programmes.",
          points: [
            "Computer training programmes",
            "Internet & e-governance access",
            "Digital awareness workshops"
          ],
          color: "success"
        },

        {
          icon: "⚖️",
          title: "RTI & Governance",
          desc:
            "Promoting transparency, accountability, and citizen participation through RTI education, governance awareness, and rights-based advocacy.",
          points: [
            "RTI awareness campaigns",
            "Rights education support",
            "Citizen participation initiatives"
          ],
          color: "danger"
        },

        {
          icon: "🏥",
          title: "Health & Hygiene",
          desc:
            "Creating awareness about sanitation, nutrition, preventive healthcare, menstrual hygiene, and overall community well-being.",
          points: [
            "Health awareness workshops",
            "Menstrual hygiene education",
            "Community sanitation drives"
          ],
          color: "warning"
        },

        {
          icon: "🛠️",
          title: "Vocational Training",
          desc:
            "Providing market-oriented skill development programmes in tailoring, beauty services, computer education, and technical trades.",
          points: [
            "Skill certification programmes",
            "Employment-oriented training",
            "Placement & livelihood support"
          ],
          color: "info"
        },

        {
          icon: "🏢",
          title: "MSME & Entrepreneurship Support",
          desc:
            "Helping artisans, youth, and rural entrepreneurs scale businesses through mentoring, market linkages, and government scheme support.",
          points: [
            "Business mentoring support",
            "Market linkage assistance",
            "Government scheme guidance"
          ],
          color: "dark"
        }
      ].map((item, index) => (

        <div className="col-lg-4 col-md-6" key={index}>

          <div
            className="card border-0 shadow-lg rounded-4 h-100 overflow-hidden position-relative"
            style={{
              transition: "0.4s ease",
              cursor: "pointer"
            }}
          >

            {/* TOP BORDER */}
            <div
              className={`bg-${item.color}`}
              style={{
                height: "8px"
              }}
            ></div>

            <div className="card-body p-5 d-flex flex-column">

              {/* ICON */}
              <div
                className={`bg-${item.color} bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center mb-4`}
                style={{
                  width: "90px",
                  height: "90px",
                  fontSize: "2.5rem"
                }}
              >
                {item.icon}
              </div>

              {/* TITLE */}
              <h3 className="fw-bold mb-3">
                {item.title}
              </h3>

              {/* DESCRIPTION */}
              <p
                className="text-muted mb-4"
                style={{
                  lineHeight: "1.8"
                }}
              >
                {item.desc}
              </p>

              {/* FEATURE LIST */}
              <ul className="list-unstyled mt-auto">

                {item.points.map((point, i) => (
                  <li
                    key={i}
                    className="d-flex align-items-start mb-3"
                  >

                    <span
                      className={`bg-${item.color} text-white rounded-circle d-inline-flex align-items-center justify-content-center me-3`}
                      style={{
                        width: "24px",
                        height: "24px",
                        fontSize: "0.8rem",
                        minWidth: "24px"
                      }}
                    >
                      ✓
                    </span>

                    <span className="text-secondary">
                      {point}
                    </span>

                  </li>
                ))}

              </ul>

            </div>

          </div>

        </div>

      ))}

    </div>

    {/* BOTTOM HIGHLIGHT */}
    <div className="row mt-5 pt-4">

      <div className="col-12">

        <div
          className="bg-dark text-white rounded-5 p-5 shadow-lg position-relative overflow-hidden"
        >

          <div className="row align-items-center g-4">

            <div className="col-lg-8">

              <span className="badge bg-warning text-dark px-3 py-2 mb-3 fw-semibold">
                COMMUNITY IMPACT
              </span>

              <h2 className="fw-bold display-6 mb-3">
                Creating Lasting Social Change
              </h2>

              <p
                className="opacity-75 fs-5 mb-0"
                style={{ lineHeight: "1.8" }}
              >
                Our programmes are designed to create sustainable
                impact by empowering individuals with knowledge,
                opportunities, skills, and confidence to build
                self-reliant communities and brighter futures.
              </p>

            </div>

            <div className="col-lg-4">

              <div className="row g-3 text-center">

                <div className="col-6">
                  <div className="bg-white bg-opacity-10 rounded-4 p-4">
                    <h2 className="fw-bold text-warning">
                      6+
                    </h2>

                    <p className="small mb-0">
                      Core Programmes
                    </p>
                  </div>
                </div>

                <div className="col-6">
                  <div className="bg-white bg-opacity-10 rounded-4 p-4">
                    <h2 className="fw-bold text-warning">
                      3
                    </h2>

                    <p className="small mb-0">
                      States Active
                    </p>
                  </div>
                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>
</section>

    {/* EDUCATIONAL RESOURCES SECTION */}
<section
  id="resources"
  className="py-5 position-relative overflow-hidden"
  style={{
    background:
      "linear-gradient(135deg, #0d6efd 0%, #0b5ed7 50%, #084298 100%)"
  }}
>
  <div className="container py-5 position-relative">

    {/* HEADER */}
    <div className="text-center text-white mb-5">

      <span className="badge bg-warning text-dark px-4 py-2 rounded-pill fw-bold mb-4">
        EDUCATIONAL RESOURCES
      </span>

      <h2 className="display-3 fw-bold mb-4">
        Empowering Communities
        <span className="text-warning"> Through Knowledge</span>
      </h2>

      <p
        className="lead mx-auto opacity-75"
        style={{
          maxWidth: "950px",
          lineHeight: "1.9"
        }}
      >
        Sfurti Charitable Trust provides practical, localized,
        and accessible educational resources designed to empower
        communities through awareness, skill development,
        digital learning, financial literacy, and rights-based education.
      </p>

    </div>

    {/* RESOURCE CARDS */}
    <div className="row g-4 justify-content-center">

      {[
        {
          icon: "📘",
          title: "RTI Made Simple",
          desc:
            "Easy-to-understand RTI learning materials available in Hindi and English to spread awareness about citizen rights and governance."
        },

        {
          icon: "💰",
          title: "Financial Literacy Manuals",
          desc:
            "Educational guides focused on savings, budgeting, banking, entrepreneurship, and financial independence."
        },

        {
          icon: "🚺",
          title: "Menstrual Hygiene Guides",
          desc:
            "Awareness materials designed to educate women and adolescent girls about menstrual health, hygiene, and wellness."
        },

        {
          icon: "📱",
          title: "WhatsApp-Based Learning",
          desc:
            "Mobile-friendly learning initiatives that share educational content directly with communities through WhatsApp."
        },

        {
          icon: "📻",
          title: "Community Radio Episodes",
          desc:
            "Awareness programmes broadcast through local community radio channels to reach rural populations effectively."
        },

        {
          icon: "💻",
          title: "Digital Learning Materials",
          desc:
            "Interactive ICT and computer learning resources focused on digital literacy and online accessibility."
        },

        {
          icon: "🏛️",
          title: "Government Scheme Guides",
          desc:
            "Simplified information about government welfare schemes, benefits, applications, and eligibility support."
        },

        {
          icon: "🎓",
          title: "Youth Skill Development",
          desc:
            "Skill-building videos and training resources designed to prepare youth for employment and entrepreneurship opportunities."
        }

      ].map((item, index) => (

        <div className="col-lg-3 col-md-6" key={index}>

          <div
            className="card border-0 rounded-4 shadow-lg h-100 overflow-hidden"
            style={{
              transition: "0.4s ease",
              cursor: "pointer"
            }}
          >

            {/* TOP SECTION */}
            <div
              className="text-center py-4"
              style={{
                background:
                  "linear-gradient(135deg, rgba(13,110,253,0.08), rgba(255,193,7,0.08))"
              }}
            >

              <div
                className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center shadow"
                style={{
                  width: "85px",
                  height: "85px",
                  fontSize: "2.4rem"
                }}
              >
                {item.icon}
              </div>

            </div>

            {/* CONTENT */}
            <div className="card-body p-4 d-flex flex-column">

              <h4 className="fw-bold mb-3 text-dark">
                {item.title}
              </h4>

              <p
                className="text-muted mb-0"
                style={{
                  lineHeight: "1.8"
                }}
              >
                {item.desc}
              </p>

            </div>

          </div>

        </div>

      ))}

    </div>

    {/* DIGITAL HUB SECTION */}
    <div className="row mt-5 pt-4">

      <div className="col-lg-10 mx-auto">

        <div
          className="bg-white rounded-5 shadow-lg overflow-hidden"
        >

          <div className="row align-items-center g-0">

            {/* LEFT */}
            <div className="col-lg-7">

              <div className="p-5">

                <span className="badge bg-warning text-dark px-3 py-2 mb-3 fw-semibold">
                  COMING SOON
                </span>

                <h2 className="fw-bold display-6 text-dark mb-4">
                  Digital Learning Hub
                </h2>

                <p
                  className="text-muted fs-5 mb-4"
                  style={{ lineHeight: "1.9" }}
                >
                  We are building a centralized digital learning
                  platform that will provide free access to
                  educational content, skill development resources,
                  vocational learning materials, awareness programmes,
                  and community training modules.
                </p>

                <div className="row g-3 mb-4">

                  <div className="col-md-6">
                    <div className="d-flex align-items-center">

                      <div
                        className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                        style={{
                          width: "40px",
                          height: "40px",
                          minWidth: "40px"
                        }}
                      >
                        ✓
                      </div>

                      <span className="text-secondary">
                        Free Learning Access
                      </span>

                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="d-flex align-items-center">

                      <div
                        className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                        style={{
                          width: "40px",
                          height: "40px",
                          minWidth: "40px"
                        }}
                      >
                        ✓
                      </div>

                      <span className="text-secondary">
                        Skill-Based Courses
                      </span>

                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="d-flex align-items-center">

                      <div
                        className="bg-warning text-dark rounded-circle d-flex align-items-center justify-content-center me-3"
                        style={{
                          width: "40px",
                          height: "40px",
                          minWidth: "40px"
                        }}
                      >
                        ✓
                      </div>

                      <span className="text-secondary">
                        Community Awareness
                      </span>

                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="d-flex align-items-center">

                      <div
                        className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                        style={{
                          width: "40px",
                          height: "40px",
                          minWidth: "40px"
                        }}
                      >
                        ✓
                      </div>

                      <span className="text-secondary">
                        Mobile-Friendly Access
                      </span>

                    </div>
                  </div>

                </div>

                <button className="btn btn-warning btn-lg px-5 py-3 fw-bold shadow">
                  Launching Soon
                </button>

              </div>

            </div>

            {/* RIGHT */}
            <div className="col-lg-5">

              <div
                className="h-100 d-flex align-items-center justify-content-center text-white text-center p-5"
                style={{
                  minHeight: "100%",
                  background:
                    "linear-gradient(135deg, #0d6efd 0%, #084298 100%)"
                }}
              >

                <div>

                  <div
                    className="bg-white text-primary rounded-circle d-inline-flex align-items-center justify-content-center shadow mb-4"
                    style={{
                      width: "120px",
                      height: "120px",
                      fontSize: "3rem"
                    }}
                  >
                    📚
                  </div>

                  <h3 className="fw-bold mb-3">
                    Learn. Grow. Empower.
                  </h3>

                  <p className="opacity-75 mb-0">
                    Accessible education and awareness tools
                    designed for sustainable social transformation.
                  </p>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>
</section>

     {/* HEALTH PROGRAMME SECTION */}
<section
  id="health"
  className="py-5 position-relative overflow-hidden"
  style={{
    background: "linear-gradient(to bottom, #f8fafc, #ffffff)"
  }}
>
  <div className="container py-5">

    <div className="row align-items-center g-5">

      {/* IMAGE SIDE */}
      <div className="col-lg-6">

        <div className="position-relative">

          {/* MAIN IMAGE */}
          <img
            src="https://images.unsplash.com/photo-1584515933487-779824d29309?auto=format&fit=crop&w=1200&q=80"
            alt="Health Programme"
            className="img-fluid rounded-5 shadow-lg"
            style={{
              objectFit: "cover",
              minHeight: "500px",
              width: "100%"
            }}
          />

          {/* FLOATING CARD */}
          <div
            className="position-absolute bg-white rounded-4 shadow-lg p-4"
            style={{
              bottom: "30px",
              left: "30px",
              maxWidth: "280px"
            }}
          >

            <div className="d-flex align-items-center mb-3">

              <div
                className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                style={{
                  width: "60px",
                  height: "60px",
                  fontSize: "1.5rem"
                }}
              >
                🏥
              </div>

              <div>
                <h5 className="fw-bold mb-0">
                  Community Health
                </h5>

                <small className="text-muted">
                  Awareness & Wellness
                </small>
              </div>

            </div>

            <p className="text-muted small mb-0">
              Improving health outcomes through awareness,
              prevention, education, and community participation.
            </p>

          </div>

        </div>

      </div>

      {/* CONTENT SIDE */}
      <div className="col-lg-6">

        <span className="badge bg-success-subtle text-success px-4 py-2 rounded-pill fw-semibold mb-4">
          HEALTH & HYGIENE PROGRAMME
        </span>

        <h2
          className="display-4 fw-bold mb-4"
          style={{ lineHeight: "1.2" }}
        >
          Building
          <span className="text-success"> Healthier </span>
          Communities
        </h2>

        {/* <p
          className="lead text-muted mb-4"
          style={{ lineHeight: "1.9" }}
        >
          Sfurti Charitable Trust believes that good health
          is the foundation of strong and empowered communities.
          Our health initiatives focus on preventive healthcare,
          sanitation, menstrual hygiene, nutrition awareness,
          and access to basic health education in underserved regions.
        </p>

        <p
          className="text-secondary fs-5 mb-5"
          style={{ lineHeight: "1.9" }}
        >
          Through awareness campaigns, mobile health camps,
          counselling support, and community engagement,
          we work to improve overall well-being and encourage
          healthy lifestyles among women, youth, children,
          and rural families.
        </p> */}

        {/* FEATURES */}
        <div className="row g-4">

          {/* ITEM 1 */}
          <div className="col-md-6">

            <div className="d-flex align-items-start">

              <div
                className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center me-3 shadow"
                style={{
                  width: "50px",
                  height: "50px",
                  minWidth: "50px"
                }}
              >
                ✓
              </div>

              <div>

                <h5 className="fw-bold mb-2">
                  Health Awareness Drives
                </h5>

                <p className="text-muted small mb-0">
                  Community campaigns promoting preventive healthcare
                  and healthy living practices.
                </p>

              </div>

            </div>

          </div>

          {/* ITEM 2 */}
          <div className="col-md-6">

            <div className="d-flex align-items-start">

              <div
                className="bg-warning text-dark rounded-circle d-flex align-items-center justify-content-center me-3 shadow"
                style={{
                  width: "50px",
                  height: "50px",
                  minWidth: "50px"
                }}
              >
                ✓
              </div>

              <div>

                <h5 className="fw-bold mb-2">
                  Menstrual Hygiene Education
                </h5>

                <p className="text-muted small mb-0">
                  Awareness programmes supporting dignity,
                  hygiene, and women’s health education.
                </p>

              </div>

            </div>

          </div>

          {/* ITEM 3 */}
          <div className="col-md-6">

            <div className="d-flex align-items-start">

              <div
                className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3 shadow"
                style={{
                  width: "50px",
                  height: "50px",
                  minWidth: "50px"
                }}
              >
                ✓
              </div>

              <div>

                <h5 className="fw-bold mb-2">
                  Mobile Health Camps
                </h5>

                <p className="text-muted small mb-0">
                  Health checkups, screenings, and medical
                  awareness camps in rural communities.
                </p>

              </div>

            </div>

          </div>

          {/* ITEM 4 */}
          <div className="col-md-6">

            <div className="d-flex align-items-start">

              <div
                className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center me-3 shadow"
                style={{
                  width: "50px",
                  height: "50px",
                  minWidth: "50px"
                }}
              >
                ✓
              </div>

              <div>

                <h5 className="fw-bold mb-2">
                  Nutrition & Sanitation
                </h5>

                <p className="text-muted small mb-0">
                  Promoting nutrition awareness and sanitation
                  practices for healthier living.
                </p>

              </div>

            </div>

          </div>

          {/* ITEM 5 */}
          <div className="col-md-6">

            <div className="d-flex align-items-start">

              <div
                className="bg-info text-dark rounded-circle d-flex align-items-center justify-content-center me-3 shadow"
                style={{
                  width: "50px",
                  height: "50px",
                  minWidth: "50px"
                }}
              >
                ✓
              </div>

              <div>

                <h5 className="fw-bold mb-2">
                  Mental Health Support
                </h5>

                <p className="text-muted small mb-0">
                  Counselling and emotional wellness support
                  initiatives for communities.
                </p>

              </div>

            </div>

          </div>

          {/* ITEM 6 */}
          <div className="col-md-6">

            <div className="d-flex align-items-start">

              <div
                className="bg-dark text-white rounded-circle d-flex align-items-center justify-content-center me-3 shadow"
                style={{
                  width: "50px",
                  height: "50px",
                  minWidth: "50px"
                }}
              >
                ✓
              </div>

              <div>

                <h5 className="fw-bold mb-2">
                  Community Participation
                </h5>

                <p className="text-muted small mb-0">
                  Engaging local stakeholders in sustainable
                  health and hygiene initiatives.
                </p>

              </div>

            </div>

          </div>

        </div>

        {/* BUTTONS */}
        <div className="d-flex flex-wrap gap-3 mt-5">

          <a
            href="#contact"
            className="btn btn-success btn-lg px-5 py-3 fw-bold shadow"
          >
            Join Our Initiative
          </a>

          <a
            href="#programs"
            className="btn btn-outline-dark btn-lg px-5 py-3"
          >
            Explore More Programmes
          </a>

        </div>

      </div>

    </div>

  </div>
</section>

      {/* SUCCESS STORIES SECTION */}
<section
  id="stories"
  className="py-5 position-relative overflow-hidden"
  style={{
    background: "linear-gradient(to bottom, #ffffff, #f8f9fa)"
  }}
>
  <div className="container py-5">

    {/* SECTION HEADER */}
    <div className="text-center mb-5">

      <span className="badge bg-primary-subtle text-primary px-4 py-2 rounded-pill fw-semibold mb-3">
        SUCCESS STORIES
      </span>

      <h2 className="display-3 fw-bold mb-4">
        Real Stories.
        <span className="text-primary"> Real Change.</span>
      </h2>

      <p
        className="lead text-muted mx-auto"
        style={{ maxWidth: "850px", lineHeight: "1.9" }}
      >
        Every programme we conduct creates meaningful change in the lives
        of individuals and communities. These inspiring stories reflect
        resilience, empowerment, and the transformative impact of
        education, skills, and opportunity.
      </p>

    </div>

    {/* STORIES ROW */}
    <div className="row g-5">

      {/* STORY 1 */}
      <div className="col-lg-6">

        <div
          className="bg-white rounded-5 shadow-lg overflow-hidden h-100 border-0"
          style={{
            transition: "0.3s"
          }}
        >

          {/* IMAGE */}
          <img
            src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=1200&q=80"
            alt="Rani Story"
            className="img-fluid"
            style={{
              height: "300px",
              width: "100%",
              objectFit: "cover"
            }}
          />

          {/* CONTENT */}
          <div className="p-5">

            <span className="badge bg-warning text-dark px-3 py-2 mb-4 fw-semibold">
              FEATURED STORY
            </span>

            <h3 className="fw-bold mb-3">
              Rani’s Journey
            </h3>

            <p
              className="fst-italic text-muted fs-5 mb-4"
              style={{ lineHeight: "1.8" }}
            >
              “I used to survive day by day — now I plan my future.”
            </p>

            <p
              className="text-secondary"
              style={{ lineHeight: "1.9" }}
            >
              Rani, a resident of Barabanki, struggled for years as an
              irregular domestic worker with limited income and no financial
              security. Through Sfurti Charitable Trust’s tailoring,
              entrepreneurship, and financial literacy programme, she gained
              confidence, practical skills, and the ability to earn
              independently.
            </p>

            <p
              className="text-secondary"
              style={{ lineHeight: "1.9" }}
            >
              Today, Rani runs her own blouse-stitching unit from home,
              supports her children’s education, and motivates other women
              in her village to join Self-Help Groups and skill programmes.
            </p>

            {/* HIGHLIGHTS */}
            <div className="row mt-4 g-3">

              <div className="col-6">
                <div className="bg-light rounded-4 p-3 text-center">
                  <h4 className="fw-bold text-warning mb-1">
                    150+
                  </h4>
                  <small className="text-muted">
                    Women Inspired
                  </small>
                </div>
              </div>

              <div className="col-6">
                <div className="bg-light rounded-4 p-3 text-center">
                  <h4 className="fw-bold text-success mb-1">
                    Self-Reliant
                  </h4>
                  <small className="text-muted">
                    Entrepreneur
                  </small>
                </div>
              </div>

            </div>

          </div>

        </div>

      </div>

      {/* STORY 2 */}
      <div className="col-lg-6">

        <div
          className="bg-white rounded-5 shadow-lg overflow-hidden h-100 border-0"
          style={{
            transition: "0.3s"
          }}
        >

          {/* IMAGE */}
          <img
            src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=1200&q=80"
            alt="Anil Story"
            className="img-fluid"
            style={{
              height: "300px",
              width: "100%",
              objectFit: "cover"
            }}
          />

          {/* CONTENT */}
          <div className="p-5">

            <span className="badge bg-primary px-3 py-2 mb-4 fw-semibold">
              SUCCESS STORY
            </span>

            <h3 className="fw-bold mb-3">
              Anil’s Breakthrough
            </h3>

            <p
              className="fst-italic text-muted fs-5 mb-4"
              style={{ lineHeight: "1.8" }}
            >
              “People used to pity me. Now they call me for work.”
            </p>

            <p
              className="text-secondary"
              style={{ lineHeight: "1.9" }}
            >
              Anil, a school dropout from Tikamgarh, faced unemployment and
              lacked opportunities to support his family. Through our
              vocational electrical repair training programme, he developed
              technical skills, confidence, and practical industry exposure.
            </p>

            <p
              className="text-secondary"
              style={{ lineHeight: "1.9" }}
            >
              Today, Anil works as a skilled electrician in nearby villages
              and trains other young people interested in technical trades.
              His journey reflects the power of vocational education in
              creating sustainable livelihoods and social respect.
            </p>

            {/* HIGHLIGHTS */}
            <div className="row mt-4 g-3">

              <div className="col-6">
                <div className="bg-light rounded-4 p-3 text-center">
                  <h4 className="fw-bold text-primary mb-1">
                    Skilled
                  </h4>
                  <small className="text-muted">
                    Electrician
                  </small>
                </div>
              </div>

              <div className="col-6">
                <div className="bg-light rounded-4 p-3 text-center">
                  <h4 className="fw-bold text-danger mb-1">
                    Youth Mentor
                  </h4>
                  <small className="text-muted">
                    Community Trainer
                  </small>
                </div>
              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

    {/* BOTTOM IMPACT SECTION */}
    <div className="row mt-5 pt-5">

      <div className="col-12">

        <div
          className="bg-dark text-white rounded-5 p-5 text-center shadow-lg"
          style={{
            background:
              "linear-gradient(135deg, #111827 0%, #1f2937 100%)"
          }}
        >

          <h2 className="fw-bold display-5 mb-4">
            Creating Stories of Hope & Transformation
          </h2>

          <p
            className="lead opacity-75 mx-auto mb-5"
            style={{
              maxWidth: "850px",
              lineHeight: "1.9"
            }}
          >
            Every individual empowered through our programmes becomes
            a catalyst for positive change in their family and community.
            Through education, livelihood support, health awareness,
            and women empowerment, we continue building brighter futures
            across underserved regions.
          </p>

          {/* IMPACT NUMBERS */}
          <div className="row g-4 justify-content-center">

            <div className="col-md-3 col-6">
              <div className="bg-white bg-opacity-10 rounded-4 p-4">
                <h2 className="fw-bold text-warning">
                  1000+
                </h2>
                <p className="mb-0 opacity-75">
                  Lives Impacted
                </p>
              </div>
            </div>

            <div className="col-md-3 col-6">
              <div className="bg-white bg-opacity-10 rounded-4 p-4">
                <h2 className="fw-bold text-success">
                  50+
                </h2>
                <p className="mb-0 opacity-75">
                  Training Programmes
                </p>
              </div>
            </div>

            <div className="col-md-3 col-6">
              <div className="bg-white bg-opacity-10 rounded-4 p-4">
                <h2 className="fw-bold text-info">
                  3+
                </h2>
                <p className="mb-0 opacity-75">
                  States Reached
                </p>
              </div>
            </div>

            <div className="col-md-3 col-6">
              <div className="bg-white bg-opacity-10 rounded-4 p-4">
                <h2 className="fw-bold text-danger">
                  2021
                </h2>
                <p className="mb-0 opacity-75">
                  Since Established
                </p>
              </div>
            </div>

          </div>

        </div>

      </div>

    </div>

  </div>
</section>

      {/* TRANSPARENCY & ACCOUNTABILITY SECTION */}
<section
  className="py-5 position-relative overflow-hidden"
  style={{
    background:
      "linear-gradient(135deg, #0f172a 0%, #111827 50%, #1e293b 100%)"
  }}
>
  <div className="container py-5">

    {/* SECTION HEADER */}
    <div className="text-center mb-5">

      <span className="badge bg-warning text-dark px-4 py-2 rounded-pill fw-semibold mb-4">
        TRANSPARENCY & ACCOUNTABILITY
      </span>

      <h2 className="display-3 fw-bold text-white mb-4">
        Building Trust Through
        <span className="text-warning"> Openness</span>
      </h2>

      <p
        className="lead text-light opacity-75 mx-auto"
        style={{
          maxWidth: "900px",
          lineHeight: "1.9"
        }}
      >
        At Sfurti Charitable Trust, transparency and accountability are
        at the core of everything we do. We believe that ethical governance,
        responsible fund management, and measurable community impact are
        essential for creating long-term social change and maintaining
        the trust of our supporters, partners, and beneficiaries.
      </p>

    </div>

    {/* MAIN CONTENT */}
    <div className="row align-items-center g-5">

      {/* LEFT CONTENT */}
      <div className="col-lg-5">

        <div className="pe-lg-4">

          <h3 className="fw-bold text-white mb-4">
            Our Commitment to Ethical Governance
          </h3>

          <p
            className="text-light opacity-75 mb-4"
            style={{ lineHeight: "1.9" }}
          >
            We ensure that every contribution, partnership,
            and programme initiative is managed with complete
            integrity, transparency, and accountability.
            Our systems are designed to ensure efficient
            utilization of resources while maximizing
            community impact.
          </p>

          <p
            className="text-light opacity-75 mb-5"
            style={{ lineHeight: "1.9" }}
          >
            Through regular audits, impact assessments,
            beneficiary participation, and transparent reporting,
            we continuously monitor our programmes to ensure
            sustainable and measurable outcomes.
          </p>

          {/* FEATURE LIST */}
          <div className="d-flex flex-column gap-4">

            <div className="d-flex align-items-start">

              <div
                className="bg-warning text-dark rounded-circle d-flex align-items-center justify-content-center fw-bold me-3 shadow"
                style={{
                  width: "55px",
                  height: "55px",
                  minWidth: "55px"
                }}
              >
                ✓
              </div>

              <div>

                <h5 className="fw-bold text-white mb-2">
                  Ethical Fund Management
                </h5>

                <p className="text-light opacity-75 small mb-0">
                  Ensuring responsible utilization of every donation
                  and resource for maximum social impact.
                </p>

              </div>

            </div>

            <div className="d-flex align-items-start">

              <div
                className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center fw-bold me-3 shadow"
                style={{
                  width: "55px",
                  height: "55px",
                  minWidth: "55px"
                }}
              >
                ✓
              </div>

              <div>

                <h5 className="fw-bold text-white mb-2">
                  Community-Centered Planning
                </h5>

                <p className="text-light opacity-75 small mb-0">
                  Beneficiary feedback and local participation
                  are integrated into programme implementation.
                </p>

              </div>

            </div>

            <div className="d-flex align-items-start">

              <div
                className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center fw-bold me-3 shadow"
                style={{
                  width: "55px",
                  height: "55px",
                  minWidth: "55px"
                }}
              >
                ✓
              </div>

              <div>

                <h5 className="fw-bold text-white mb-2">
                  Continuous Impact Monitoring
                </h5>

                <p className="text-light opacity-75 small mb-0">
                  Regular reviews and assessments ensure effective
                  programme delivery and measurable outcomes.
                </p>

              </div>

            </div>

          </div>

        </div>

      </div>

      {/* RIGHT SIDE CARDS */}
      <div className="col-lg-7">

        <div className="row g-4">

          {/* CARD 1 */}
          <div className="col-md-6">

            <div
              className="bg-white bg-opacity-10 backdrop-blur rounded-5 p-5 h-100 shadow-lg border border-light border-opacity-10"
              style={{
                transition: "0.3s"
              }}
            >

              <div className="display-3 mb-4">
                📊
              </div>

              <h4 className="fw-bold text-white mb-3">
                Financial Audits
              </h4>

              <p
                className="text-light opacity-75"
                style={{ lineHeight: "1.8" }}
              >
                Annual financial audits are conducted by certified
                Chartered Accountants to ensure complete financial
                compliance, accountability, and transparency.
              </p>

            </div>

          </div>

          {/* CARD 2 */}
          <div className="col-md-6">

            <div
              className="bg-white bg-opacity-10 backdrop-blur rounded-5 p-5 h-100 shadow-lg border border-light border-opacity-10"
              style={{
                transition: "0.3s"
              }}
            >

              <div className="display-3 mb-4">
                🔍
              </div>

              <h4 className="fw-bold text-white mb-3">
                Fund Traceability
              </h4>

              <p
                className="text-light opacity-75"
                style={{ lineHeight: "1.8" }}
              >
                We maintain complete transparency in tracking
                resources from donors and partners directly
                to programme beneficiaries and communities.
              </p>

            </div>

          </div>

          {/* CARD 3 */}
          <div className="col-md-6">

            <div
              className="bg-white bg-opacity-10 backdrop-blur rounded-5 p-5 h-100 shadow-lg border border-light border-opacity-10"
              style={{
                transition: "0.3s"
              }}
            >

              <div className="display-3 mb-4">
                🤝
              </div>

              <h4 className="fw-bold text-white mb-3">
                Community Participation
              </h4>

              <p
                className="text-light opacity-75"
                style={{ lineHeight: "1.8" }}
              >
                Local communities and beneficiaries actively
                participate in programme planning, feedback,
                monitoring, and evaluation processes.
              </p>

            </div>

          </div>

          {/* CARD 4 */}
          <div className="col-md-6">

            <div
              className="bg-white bg-opacity-10 backdrop-blur rounded-5 p-5 h-100 shadow-lg border border-light border-opacity-10"
              style={{
                transition: "0.3s"
              }}
            >

              <div className="display-3 mb-4">
                📈
              </div>

              <h4 className="fw-bold text-white mb-3">
                Monitoring & Evaluation
              </h4>

              <p
                className="text-light opacity-75"
                style={{ lineHeight: "1.8" }}
              >
                Periodic impact assessments, field monitoring,
                and progress reports help ensure long-term
                effectiveness and sustainable development.
              </p>

            </div>

          </div>

        </div>

      </div>

    </div>

    {/* IMPACT STRIP */}
    <div className="row mt-5 pt-5">

      <div className="col-12">

        <div
          className="bg-warning text-dark rounded-5 p-5 shadow-lg"
        >

          <div className="row align-items-center g-4">

            <div className="col-lg-8">

              <h2 className="fw-bold mb-3">
                Accountability Creates Sustainable Impact
              </h2>

              <p
                className="mb-0 fs-5"
                style={{ lineHeight: "1.8" }}
              >
                By maintaining strong governance practices and transparent
                operations, we continue building trust with communities,
                supporters, institutions, and stakeholders across India.
              </p>

            </div>

            <div className="col-lg-4 text-lg-end">

              <a
                href="#contact"
                className="btn btn-dark btn-lg px-5 py-3 fw-bold shadow"
              >
                Partner With Us
              </a>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>
</section>

      {/* CONTACT SECTION */}
<footer
  id="contact"
  className="position-relative overflow-hidden text-white"
  style={{
    background:
      "linear-gradient(135deg, #000000 0%, #111827 50%, #1f2937 100%)"
  }}
>

  {/* TOP CONTACT AREA */}
  <div className="container py-5">

    <div className="row align-items-center g-5">

      {/* LEFT CONTENT */}
      <div className="col-lg-6">

        <span className="badge bg-warning text-dark px-4 py-2 rounded-pill fw-semibold mb-4">
          CONTACT US
        </span>

        <h2 className="display-3 fw-bold mb-4">
          Let’s Build
          <span className="text-warning"> Change </span>
          Together
        </h2>

        <p
          className="lead opacity-75 mb-5"
          style={{ lineHeight: "1.9" }}
        >
          Join our mission to empower communities through education,
          health awareness, women empowerment, digital literacy,
          and sustainable livelihood opportunities.
          Together, we can create stronger, healthier,
          and more self-reliant communities across India.
        </p>

        {/* CONTACT DETAILS */}
        <div className="d-flex flex-column gap-4">

          {/* ADDRESS */}
          <div className="d-flex align-items-start">

            <div
              className="bg-warning text-dark rounded-circle d-flex align-items-center justify-content-center me-4 shadow"
              style={{
                width: "65px",
                height: "65px",
                minWidth: "65px",
                fontSize: "1.5rem"
              }}
            >
              📍
            </div>

            <div>

              <h5 className="fw-bold mb-2">
                Office Address
              </h5>

              <p
                className="opacity-75 mb-0"
                style={{ lineHeight: "1.8" }}
              >
                F-29/9G, Avas Vikas Staff Flats,
                Near Amrapali Market,
                Indira Nagar, Lucknow,
                Uttar Pradesh, India
              </p>

            </div>

          </div>

          {/* EMAIL */}
          <div className="d-flex align-items-start">

            <div
              className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-4 shadow"
              style={{
                width: "65px",
                height: "65px",
                minWidth: "65px",
                fontSize: "1.5rem"
              }}
            >
              📧
            </div>

            <div>

              <h5 className="fw-bold mb-2">
                Email Address
              </h5>

              <p className="opacity-75 mb-0">
                info.sfurti@gmail.com
              </p>

            </div>

          </div>

          {/* PHONE */}
          <div className="d-flex align-items-start">

            <div
              className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center me-4 shadow"
              style={{
                width: "65px",
                height: "65px",
                minWidth: "65px",
                fontSize: "1.5rem"
              }}
            >
              📞
            </div>

            <div>

              <h5 className="fw-bold mb-2">
                Contact Number
              </h5>

              <p className="opacity-75 mb-0">
                +91 99848 99998
              </p>

            </div>

          </div>

        </div>

      </div>

      {/* RIGHT SIDE */}
      <div className="col-lg-6">

        <div
          className="bg-white bg-opacity-10 border border-light border-opacity-10 rounded-5 p-5 shadow-lg h-100"
          style={{
            backdropFilter: "blur(12px)"
          }}
        >

          <h3 className="fw-bold mb-4 text-warning">
            Why Connect With Us?
          </h3>

          <p
            className="opacity-75 mb-5"
            style={{ lineHeight: "1.9" }}
          >
            We welcome partnerships, collaborations, volunteer
            participation, donations, and community support to
            expand our social impact initiatives across underserved
            regions.
          </p>

          {/* FEATURE LIST */}
          <div className="d-flex flex-column gap-4">

            <div className="d-flex align-items-start">

              <div className="me-3 fs-3 text-warning">
                🤝
              </div>

              <div>
                <h5 className="fw-bold mb-1">
                  Partnership Opportunities
                </h5>

                <p className="small opacity-75 mb-0">
                  Collaborate with us to create sustainable social impact.
                </p>
              </div>

            </div>

            <div className="d-flex align-items-start">

              <div className="me-3 fs-3 text-primary">
                🌱
              </div>

              <div>
                <h5 className="fw-bold mb-1">
                  Community Development
                </h5>

                <p className="small opacity-75 mb-0">
                  Support grassroots programmes that transform lives.
                </p>
              </div>

            </div>

            <div className="d-flex align-items-start">

              <div className="me-3 fs-3 text-success">
                🎓
              </div>

              <div>
                <h5 className="fw-bold mb-1">
                  Education & Skill Training
                </h5>

                <p className="small opacity-75 mb-0">
                  Help empower youth and women through learning initiatives.
                </p>
              </div>

            </div>

            <div className="d-flex align-items-start">

              <div className="me-3 fs-3 text-danger">
                ❤️
              </div>

              <div>
                <h5 className="fw-bold mb-1">
                  Volunteer Engagement
                </h5>

                <p className="small opacity-75 mb-0">
                  Become part of our mission to build empowered communities.
                </p>
              </div>

            </div>

          </div>

          {/* CTA BUTTONS */}
          <div className="d-flex flex-wrap gap-3 mt-5">

            <a
              href="mailto:info.sfurti@gmail.com"
              className="btn btn-warning btn-lg px-4 py-3 fw-bold shadow"
            >
              Email Us
            </a>

            <a
              href="tel:+919984899998"
              className="btn btn-outline-light btn-lg px-4 py-3"
            >
              Call Now
            </a>

          </div>

        </div>

      </div>

    </div>

  </div>

  {/* FOOTER BOTTOM */}
  <div className="border-top border-secondary border-opacity-25">

    <div className="container py-4">

      <div className="row align-items-center g-3">

        {/* LEFT */}
        <div className="col-lg-6">

          <p className="mb-1 text-light opacity-75">
            © 2026 Sfurti Charitable Trust.
            Together, We Build Change That Lasts.
          </p>

          <small className="text-secondary">
            Registered NGO | Registration No: 203/2021-22
          </small>

        </div>

        {/* RIGHT */}
        <div className="col-lg-6 text-lg-end">

          <div className="d-flex justify-content-lg-end gap-4 flex-wrap">

            <a
              href="#home"
              className="text-decoration-none text-light opacity-75"
            >
              Home
            </a>

            <a
              href="#about"
              className="text-decoration-none text-light opacity-75"
            >
              About
            </a>

            <a
              href="#programs"
              className="text-decoration-none text-light opacity-75"
            >
              Programmes
            </a>

            <a
              href="#stories"
              className="text-decoration-none text-light opacity-75"
            >
              Stories
            </a>

          </div>

        </div>

      </div>

    </div>

  </div>

</footer>

    </div>
  );
}
